import type { ReactNode } from "react";
import "./pages.css";

export function PageHeader({ title, titleAction, eyebrow, actions, tabs, meta, className = "" }: {
  title: ReactNode; titleAction?: ReactNode; eyebrow?: string; actions?: ReactNode; tabs?: ReactNode; meta?: ReactNode; className?: string;
}) {
  return <header className={`ui-page-header ${tabs ? "ui-page-header--navigation" : ""} ${className}`.trim()}>
    <div className="ui-page-title">{eyebrow && <span>{eyebrow}</span>}{titleAction ? <div className="ui-page-title-line"><h1>{title}</h1>{titleAction}</div> : <h1>{title}</h1>}{meta}</div>
    {tabs && <div className="ui-page-tabs">{tabs}</div>}
    {actions && <div className="workflow-actions">{actions}</div>}
  </header>;
}
